<script setup lang="ts">
</script>

<template>
    <div class="bg-base-200 border-t border-border flex flex-col lg:gap-0 py-6 overflow-x-hidden">
        <div class="m-auto w-full max-w-8xl px-2">
            <section class="flex lg:flex-wrap justify-start gap-2 lg:gap-4 relative pb-10 lg:pb-0">
                <img
                    src="/images/footer_seal.png"
                    class="footer-seal object-contain max-w-15 lg:max-w-21"
                    :alt="$t('layout.footerLight.sealAlt')"
                    loading="lazy"
                >

                <div class="m-auto">
                    <div class="flex flex-row lg:flex-col flex-nowrap gap-4">
                        <p class="text-left lg:text-center text-sm">
                            {{ $t('layout.footerLight.copyright') }} |
                            <FoundationLink
                                type="external"
                                class="text-neutral text-sm hover:underline"
                                href="https://goo.gl/maps/Y5LDnNDc1zWiw39J6"
                                target="_blank"
                                rel="noopener">
                                {{ $t('layoutJuppen.footerJuppen.howToFindUs') }}
                            </FoundationLink>
                        </p>
                        <p class="text-center lg:pb-5 text-base">{{ $t('layoutJuppen.footerJuppen.copyrightExtraInfo') }}</p>
                    </div>
                    <p class="text-sm text-center absolute bottom-0 lg:relative lg:bottom-auto w-100 left-1/2 -translate-x-1/2">{{ $t('layout.footerLight.hint') }}</p>
                </div>
            </section>
        </div>
    </div>
</template>
